import store from '@Store';
import { firstParameterState } from '@Utils/Decorators/NgServices';

import { zoomValueByKey } from '@Containers/Zoom/ZoomSelectors';

import { setZoomValue } from '@Containers/Zoom/ZoomAction';

const zoomValueByKeyNg = firstParameterState(zoomValueByKey);

export default {
  getZoomForKey,
  storeZoomForKey,
};

function getZoomForKey(key) {
  return zoomValueByKeyNg({ zoomKey: key });
}

function storeZoomForKey(zoomLevel, key) {
  store.dispatch(setZoomValue(key, zoomLevel));
}
